require('./audio-file.component.scss');

const MEDIA_ERR_ABORTED = 1; // fetching process aborted by user
const MEDIA_ERR_NETWORK = 2; // error occurred when downloading
const MEDIA_ERR_DECODE = 3; // error occurred when decoding
const MEDIA_ERR_SRC_NOT_SUPPORTED = 4; // audio/video not supported

const MEDIA_ERROR_CODE = {
  '1': gettext('Отменено'),
  '2': gettext('Ошибка сети'),
  '3': gettext('Ошибка кодека'),
  '4': gettext('Не поддерживается'),
};

/*@ngInject*/
class AudioFileController {
  constructor($scope, $http, AudioService) {
    this.$http = $http;
    this.audioService = AudioService;
    this.currentTime = 0;
    this.duration = 0;
    this.audioErrors = MEDIA_ERROR_CODE;
    this.playing = false;

    // error occurred during the loading or playing
    this.onError = () => {
      // if (this.audio.error.code === MEDIA_ERR_NETWORK) {
      //   this.reload();
      // }
      this.playing = false;
      $scope.$digest();
    };

    // the audio has been started or is no longer paused
    this.onPlay = () => {
      this.playing = true;
      $scope.$digest();
    };

    // the audio has been paused
    this.onPause = () => {
      this.playing = false;
      $scope.$digest();
    };

    // the audio is ended
    this.onEnded = () => {
      this.playing = false;
      $scope.$digest();
    };

    // duration data is changed
    this.onDurationChange = () => {
      this.updateDuration();
      $scope.$digest();
    };

    // position is changed
    this.onTimeUpdate = () => {
      this.updateCurrentTime();
      $scope.$digest();
    };
  }

  reload() {
    if (this.reloading) {
      return;
    }
    this.reloading = true;
    if (this.audio.error.code === MEDIA_ERR_DECODE ||
      this.audio.error.code === MEDIA_ERR_SRC_NOT_SUPPORTED) {
      return this.$http.get(this.audio.src + '&reset=true')
        .catch(err => {
          if (err.status === 404) {
            return;
          }
          console.error(err.message);
        })
        .finally(() => this.reloadAudio());
    }
    this.reloadAudio();
  }

  reloadAudio() {
    this.audio.load();
    this.updateDuration();
    this.updateCurrentTime();
    this.reloading = false;
  }

  $onInit() {
    this.createAudio();
  }

  $onDestroy() {
    this.disposeAudio();
  }

  createAudio() {
    let audio = this.audio = this.fact.audio =
      this.fact.audio || this.audioService.createAudio(this.src);
    audio.addEventListener('error', this.onError);
    audio.addEventListener('play', this.onPlay);
    audio.addEventListener('pause', this.onPause);
    audio.addEventListener('ended', this.onEnded);
    audio.addEventListener('timeupdate', this.onTimeUpdate);
    audio.addEventListener('durationchange', this.onDurationChange);
    this.updateDuration();
    this.updateCurrentTime();
  }

  disposeAudio() {
    let audio = this.audio;
    audio.removeEventListener('error', this.onError);
    audio.removeEventListener('play', this.onPlay);
    audio.removeEventListener('pause', this.onPause);
    audio.removeEventListener('ended', this.onEnded);
    audio.removeEventListener('timeupdate', this.onTimeUpdate);
    audio.removeEventListener('durationchange', this.onDurationChange);
    //this.fact.audio = null;
    //this.fact.audioLoad = false;
  }

  play() {
    this.audioService.play(this.audio);
    this.fact.audioLoad = true;
  }

  updateDuration() {
    let duration = this.audio.duration;
    this.duration = Math.floor(duration);
  }

  updateCurrentTime() {
    this.currentTime = Math.floor(this.audio.currentTime);
  }

  get downloadSrc() {
    return this.audioService.getSrcType(
      this.src,
      this.audioService.downloadType,
    );
  }

  onSeek() {
    this.audio.currentTime = this.currentTime;
  }

  get showTime() {
    return this.playing || this.isSelected && this.hasDuration;
  }

  get isSelected() {
    return this.fact.selected;
  }

  get hasDuration() {
    return typeof this.audio.duration === 'number' &&
      !isNaN(this.audio.duration) && isFinite(this.audio.duration);
  }
}

export const AudioFileComponent = {
  template  : require('./audio-file.component.html'),
  controller: AudioFileController,
  bindings  : {
    fact: '<',
    src : '<',
  },
  // resolve: '^facts'
};



// WEBPACK FOOTER //
// ./src/facts/audio/audio-file.component.js